export default {
    props: {
        tabObj: {
            type: Object
        }
    },
    
    data: function () {
        return {}
    }
}